import { FunctionComponent, PropsWithChildren, memo, useContext } from 'react';
import { ConfigContext } from '../../../context';
import { getOrganisationDomain } from '../../../shared';

import classNames from 'classnames';
import classes from './Form.module.scss';

export enum AlignContentOptions {
  left = 'left',
  center = 'center',
  right = 'right',
}

interface FormProps {
  alignContent?: AlignContentOptions;
}

export const Form: FunctionComponent<PropsWithChildren<FormProps>> = memo(
  ({ alignContent, children }) => {
    const { config } = useContext(ConfigContext);

    const {
      organisationLogoUrl,
      meta: { title },
    } = config.elements;

    return (
      <main className={classes['form']}>
        <img
          src={
            ['afz'].includes(getOrganisationDomain())
              ? 'https://upload.wikimedia.org/wikipedia/commons/6/6f/Dfv_Mediengruppe_Logo.svg'
              : organisationLogoUrl
          }
          className={classes['form__logo']}
          alt={title}
        />
        <form
          className={classNames(
            classes['form__content'],
            classes[`form__content--${alignContent}`]
          )}
          autoComplete="off"
          onSubmit={(e) => e.preventDefault()}
        >
          {children}
        </form>
      </main>
    );
  }
);
